import RadioElement from "components/Elements/RadioElement/RadioElement";
import parse from "html-react-parser";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";

import styles from "./cancelSubscription.module.scss";

interface CancelSubscriptionRadioOptionsI {
  cancelType: string;
  setCancelType: (option: string) => void;
}

const CancelSubscriptionOptions = ({
  cancelType,
  setCancelType,
}: CancelSubscriptionRadioOptionsI) => {
  const { getTextByKey } = useContent();
  const { getUserData, getUserBillingDetails } = useUser();
  const userBillingDetails = getUserBillingDetails();

  const handleOptionSelect = (option: string) => {
    setCancelType(option);
  };

  const parsedDate = (date: string) => {
    const dateObj = new Date(date);
    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
    return `${year}/${month}/${day}`;
  };

  return (
    <div className={styles.radioOptionsContainer}>
      <h3>{getTextByKey("cancel-subscription-options-title")}</h3>
      {/* <h3>{getTextByKey(`cancel-subscription-options-title-${cancelType}`)}</h3> */}
      <div className={styles.optionsWrapper}>
        <RadioElement
          state={cancelType}
          setState={handleOptionSelect}
          fieldToCheck="stop-renewal"
          textRadioObject={getTextByKey("stop-subscription-renewal")}
        />
        <RadioElement
          state={cancelType}
          setState={handleOptionSelect}
          fieldToCheck="cancel-immediately"
          textRadioObject={getTextByKey("cancel-subscription-immediately")}
        />
      </div>
      <div className={styles.infoBox}>
        <p className={styles.infoText}>
          {parse(
            cancelType === "stop-renewal"
              ? getTextByKey("cancel-subscription-info").replace(
                  "#date#",
                  parsedDate(getUserData().SubscribationExpirationDate)
                )
              : userBillingDetails.payment_gateway === "WIRE"
              ? getTextByKey("cancel-subscription-disabled-due-to-wire")
              : getTextByKey("cancel-subscription-info-immediately")
          )}
        </p>
      </div>
    </div>
  );
};

export default CancelSubscriptionOptions;
